// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + chunkId + ".js?v=" + {"640":"76c54c7ab8b634ac1afe","1642":"a118a4db4cfaa015f956","2979":"64e6ee4c660b7ba1d7a7","5771":"d141d1ad8187d99738b9","5810":"a3400d11c822baeddef2","7471":"6423b9b898ffefeb7d1d"}[chunkId] + "";
};